import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      "Mobile": "Mobile",
      "Email": "Email",
      "Dob": "Dob",
      "Blood Group": "Blood Group",
      "Address": "Address",
      "My Certifications": "My Vaccination Certifications",
      "FCC Membership ID": "FCC Membership ID",
      "Select Language": "Select Language",
      "Data not found": "Data not found",
      "My Sites":"My Sites",
      "My Achievements":"My Achievements",
      "My FCC Moments":"My FCC Moments"
    }
  },
  hn: {
    translation: {
      "Mobile": "मोबाइल",
      "Email": "ईमेल",
      "Dob": "जन्म तिथि",
      "Blood Group": "रक्त समूह",
      "Address": "पता",
      "My Certifications": "मेरे टीकाकरण प्रमाणपत्र",
      "FCC Membership ID": "एफसीसी सदस्यता आईडी",
      "Select Language": "भाषा का चयन करें",
      "Data not found": "डेटा नहीं मिला",
      "My Sites":"मेरी साइट",
      "My Achievements":"मेरी उपलब्धियां",
      "My FCC Moments":"माई एफसीसी मोमेंट्स",
      "Ratings & Reviews":"रेटिंग और समीक्षाएं",
      "Ratings":"रेटिंग",
      "Reviews":"समीक्षाएं",
      "WRITE A REVIEW":"एक समीक्षा लिखें",
      "Full Name":"पूरा नाम",
      "Enter phone number":'फोन नंबर दर्ज',
      "Enter OTP":"ओटीपी दर्ज करें",
      "Resend OTP":'ओटीपी पुनः भेजें',
      "Cancel":'रद्द करें',
      "Submit":"सहेजें",
      "Tier":"टीयर",
      "Designation":'पद का नाम',
      "Vaccinated":"टीका लगाया",
      "Write Comment":'टिप्पणी लिखे'

    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
